import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SHOW_INVALID_SUBMISSION_DIALOG } from "submission/submissionActions";
import { getInvalidSubmissionDialogVisible } from "common/selectors";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";

import IntlDialogActions from "../../general-components/IntlDialogActions";

const InvalidSubmissionDialog = () => {
  const { t } = useTranslation();
  const visible = useSelector(getInvalidSubmissionDialogVisible);

  const dispatch = useDispatch();
  const onCancel = () =>
    dispatch({ type: SHOW_INVALID_SUBMISSION_DIALOG, show: false });

  return (
    <Dialog
      open={visible}
      onClose={onCancel}
      aria-labelledby="invalid-submission-dialog-title"
      aria-describedby="invalid-submission-dialog-description"
    >
      <DialogTitle id="invalid-submission-dialog-title">
        {t("submission_invalid_title")}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          color="primary"
          id="invalid-submission-dialog-description"
        >
          {t("submission_invalid_message")}
        </DialogContentText>
      </DialogContent>

      <IntlDialogActions>
        <Button color="primary" onClick={onCancel}>
          {t("submission_invalid_ok")}
        </Button>
      </IntlDialogActions>
    </Dialog>
  );
};

export default InvalidSubmissionDialog;
